import React from "react";

import { CMS } from "../../../components/Routes/lazyImport";
import { PageCmsCustom } from "../PageCmsCustom"; // TODO: do lazyImport
import { IPrismicPage } from "../PageCmsCustom/types";

import { usePrismicData } from "./usePrismicData";

export const CMSTemplate = ({
  cmsType,
  cmsId,
}: IPrismicPage): JSX.Element | null => {
  const data = usePrismicData({ cmsId, cmsType });

  if (!data) {
    return null;
  }

  /**
   * Handle Prismic custom type:
   * "page_cms_import" (v2 tab)
   *
   * Custom page builder
   */
  if (data.v2_page_active) {
    return <PageCmsCustom cmsId={cmsId} cmsType={cmsType} data={data} />;
  }

  /**
   * Handle Prismic custom type:
   * "page_cms_import" (main tab)
   *
   * HTML to React parser
   */
  return <CMS cmsId={cmsId} cmsType={cmsType} data={data} />;
};
